import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../Forms/Element/CustomSelect';
import axiosInstance from '../../../../../services/AxiosInstance';
import Api from '../../../../../constants/Api';

/**
 * Componente responsável por listar as filiais.
 */
const BranchSelect = (props) => {

  const { t } = useTranslation();
  const [entities, setEntities] = useState([]);

  useEffect(() => {
    
    function findAll() {
      setEntities([]);

      axiosInstance.get(Api.main.branch + "/user")
        .then(response => {
          let entities = [];

          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].status === 'ACTIVE') {
              entities.push(
                {
                  value: response.data[i].id,
                  label: response.data[i].name
                }
              );
            }
          }
          setEntities(entities);
        });
    }

    findAll();
  }, []);

  return (
    <CustomSelect options={entities} error={props.error} value={props.value} onChange={props.onChange} isClearable placeholder={props.placeholder || t("select")} isDisabled={props.isDisabled} />
  )
}

export default BranchSelect;